import {
    SET_LOADING,
    GET_DR_QUOTATION,
    SEARCH_INPUT,
    SI_DATA,
    BOOLEAN_VAR,
    GET_DR,
    HANDLE_SI_SELECT_PAYMENT_TYPE,
    GET_SI_TERMS_CONDITIONS,
    HANDLE_SI_SELECT_TERMS_CONDITIONS,
    HANDLE_SI_SELECT_TYPE_RECEIPT,
    MANUAL,
    HANDLE_SELECT_SI_TEMPLATE,
    GET_SI_TEMPLATES,
    GET_SI_CUSTOMERS,
    GET_QUOTATION_PRODUCTS,
    HANDLE_SI_SELECT_CUSTOMER,
    HANDLE_SI_SELECT_BRANCH,
    SET_DR_TYPE_FILTER,
    HANDLE_SI_SELECT_ITEM,
    ADD_ITEM,
    TOGGLE_DISCOUNT_ROW,
    SET_LAST_ADDED_DROPDOWN_INDEX,
    REMOVE_ITEM,
    COMPUTE_DR,
    SORT_BY_COLUMN,
    SET_MODAL,
    MODAL_LOADING,
    CLEAR_DELIVERY,
    DELIVERY_CLEAR_UPLOAD,
    DELIVERY_TAX_SELECT_TYPE,
    DELIVERY_COMPUTATION_HANDLER,
    DELIVERY_INPUT_CHANGE,
    SEND_EMAIL,
    RESEND_EMAIL,
    PRE_LOAD,
    DOWNLOAD_BTN,
    EMAIL_SETTING_DATA,
    DR_REDIRECT,
    GET_DR_TEMPLATES,
    SELECT_DR_TEMPLATE,
    DYNAMIC_SEND_EMAIL,
    GET_DR_ROWS_TO_DELETE,
    CLEAR_DATA,
    BTN_FORM,
    GET_STATUS,
    GET_DR_STATUS,
    SET_CREATE_SO,
    SET_GENERATE_SO,
    DR_SET_CUSTOMER_TYPE,
    GET_DR_BRANCH_OPTIONS,
    HANDLE_ITEM_FORM_DISABLE,
    CREATE_PRODUCT,
    SET_DATE_PICKER,
    DR_INPUT_CHANGE,
    SET_DR_PICKING_TEMPLATE,
} from '../../types';
import {
    ToastSuccess,
    ToastDanger,
    ToastWarning,
} from '../../../Services/_toast.service';
import $, { map } from 'jquery';
import { DeliveryService } from './_service.delivery';
import {
    SwalWarning,
    SwalError,
    SwalSuccessAutoRemove,
    SwallverfiyPass,
    SwalWarningHtml,
} from '../../../Services/_swal.service';
import { DialogTitle } from '@material-ui/core';
import { blockRoute } from '../helper/helper.actions';
import {
    getNumRows,
    settoPrint,
    gettoPrint,
    getUserData,
} from '../../../Utils/Common';
import {
    getSingleSalesOrder,
    soClearUpload,
} from './../sales_order/sales_order.actions';
import { ProductService } from '../product/_service.product';

export const handleChangeStatusView =
    (status_view) => async (dispatch, getState) => {
        dispatch({ type: GET_STATUS, payload: status_view });

        let { search, dr_data } = getState().delivery;

        if (
            typeof dr_data[status_view] === 'undefined' ||
            dr_data[status_view] == null
        ) {
            dispatch({ type: SEARCH_INPUT, payload: '' });
            dispatch(get_dr(1));
        } else {
            dispatch({
                type: SEARCH_INPUT,
                payload: dr_data[status_view].search,
            });
            dispatch({
                type: GET_DR,
                payload: {
                    dr_data: dr_data,
                    pagination: dr_data[status_view],
                },
            });
        }
    };

export const handleChangeDrTypeFilter = (type) => async (dispatch) => {
    dispatch({ type: SET_DR_TYPE_FILTER, payload: type });
    dispatch(get_dr(1));
};

export const fetchQuotations = (value) => async () => {
    return DeliveryService.getQuotations({ search: value })
        .then((result) => {
            // transform the data into the format needed by the select component
            return result.data.quotation.data.map((data) => {
                return {
                    label: data.quotation_no,
                    value: data._id,
                    name: 'quotation',
                };
            });
        })
        .catch((err) => {
            ToastDanger('Failed to load Quotation.');
            // return an empty array if there was an error
            return [];
        });
};

export const getQuotations = () => async (dispatch, getState) => {
    const { search } = getState().delivery;
    const formdat = {
        search: search,
    };
    DeliveryService.getQuotations(formdat)
        .then((result) => {
            // console.log("result", result.data.quotation.data);
            const quotation = result.data.quotation.data;
            const arr = [];
            quotation.map((data) => {
                arr.push({
                    label: data.quotation_no,
                    value: data._id,
                    name: 'quotation',
                });
            });

            dispatch({ type: GET_DR_QUOTATION, payload: arr });
        })
        .catch((err) => {
            ToastDanger('Failed to load Quotation.');
        });
};

export const searchQuotation = (value) => async (dispatch) => {
    if (value.length >= 3) {
        fetchQuotations(value).then((results) => {
            dispatch({ type: GET_DR_QUOTATION, payload: results });
        });
    }
};

export const getQuotationItems = (val) => async (dispatch, getState) => {
    if (val) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    // console.log(val)
    dispatch({ type: SET_LOADING, payload: true });
    dispatch({ type: BOOLEAN_VAR, payload: true });
    DeliveryService.getItems(val.value)
        .then((result) => {
            const si_result = result.data.quotation;
            const _discount =
                si_result.discount_type == 1
                    ? (si_result.discount / 100) * si_result.sub_total
                    : si_result.discount;
            let _qty = 0;
            si_result.quotation_items.map((data, index) => {
                _qty += data.qty;
            });

            let { items } = getState().delivery;
            let item_data = [];
            // console.log("si_result", si_result);
            si_result.quotation_items.map((data, key) => {
                // console.log("data", data);
                let temp_item = {
                    items: items,
                    _id: data.product_id,
                    product_id: data.product_id,
                    sku: data.sku,
                    product_name: data.product_name,
                    attribute_string: data.attribute_string,
                    qty: data.qty,
                    product_unit_name: data.product_unit_name,
                    srp: data.srp,
                    // unit_price: data.unit_price ? data.unit_price : data.srp,
                    amount: data.amount,
                    product_value: {
                        value: data.product_id,
                        label: data.product_name,
                    },
                    description: data ? data.description : '',
                    brand: data ? data.brand : '',
                    status_code: data ? data.status_code : 0,
                    barcode: data ? data.barcode : '',
                    discount: data.discount,
                    discount_type: data.discount_type
                        ? data.discount_type
                        : { value: null },
                    discount_amount: data.discount_amount
                        ? data.discount_amount
                        : 0,
                    new: true,
                    unit_price: data.srp,
                    unit_srp: data.srp,
                    product_units: data.product_units,
                    conversion_to_base: data.conversion_to_base,
                    unit_barcode: data.barcode,
                };
                item_data.push(temp_item);
            });
            // console.log("si_result._id", si_result._id);
            const si_data = {
                items: item_data,
                customer: si_result.customer.name,
                customer_id: si_result.customer._id,
                sub_total: si_result.sub_total,
                discount: _discount,
                discount_type: si_result.discount_type,
                tax: si_result.tax,
                vat_amount: si_result.vat_amount ? si_result.vat_amount : 0.0,
                tax_type: si_result.tax_type
                    ? si_result.tax_type
                    : { value: 'none', label: 'None' },
                delivery_fee: si_result.other,
                total: si_result.total,
                remarks: si_result.remarks,
                terms_and_condition: si_result.terms_and_condition,
                payment_details: si_result.payment_details,
                internal_notes: si_result.internal_notes,
                total_qty: _qty,
                payment_terms: SiCatcher(si_result.payment_terms),
                receipt_type: SiCatcher(si_result.receipt_type),
                payment_mode: SiCatcher(si_result.payment_mode),
                status: '',
                manual_input: false,
                // serial_no: si_result.serial_no,
                quotation_no: si_result.quotation_no,
            };

            // console.log("si_data in getQuotationItems:", si_data);
            // console.log(si_data)

            dispatch({
                type: SI_DATA,
                payload: { data: si_data, _id: si_result._id },
            });
            dispatch({ type: SET_LOADING, payload: false });
            dispatch({ type: BOOLEAN_VAR, payload: false });
            dispatch({ type: PRE_LOAD, payload: true });
        })
        .catch((err) => {
            dispatch({ type: SET_LOADING, payload: false });
            console.log(err);
        });
};

const SiCatcher = (data) => {
    if (data === undefined && data == null) {
        data = {
            value: '',
            label: '',
        };
    }

    return data;
};

export const sumbit_delivery =
    (formdata, actions) => async (dispatch, getState) => {
        let { si_data, quotation_id } = getState().delivery;

        if (si_data.delivery_template_id == '') {
            return ToastDanger('Please Choose Delivery Template');
        }

        // if (si_data.manual_input === false && quotation_id === null) {
        //     return ToastDanger(
        //         'Please Choose Quotation or create manually'
        //     );
        // }

        if (si_data.is_selected === false) {
            return ToastDanger(
                'Please select if you want to Generate Sales Order'
            );
        }

        if (si_data.manual_input) {
            quotation_id = null;
        }

        if (si_data.manual_input === true) {
            quotation_id = null;

            // if (si_data.reference_no === '') {
            //     return ToastDanger('Reference NO is required.');
            // }
        }

        if (si_data.items.length === 0) {
            return ToastDanger('Please add Product item at least one.');
        } else {
            for (let item of si_data.items) {
                if (item.qty <= 0) {
                    return ToastDanger(
                        'Quantity cannot be zero value, please add at least 1'
                    );
                }
                if (item.srp <= 0) {
                    return ToastDanger(
                        'Unit Price cannot be zero value, please include at least the amount'
                    );
                }

                if (item.product_name === '') {
                    return ToastDanger('Please add a Product Name');
                }

                if (item.sku === '') {
                    return ToastDanger('Please add an SKU');
                }

                if (item.product_unit_name === '') {
                    return ToastDanger('Please add a Product Unit');
                }
            }
        }

        if (
            (si_data.discount_type.value === 'percent' ||
                si_data.discount_type.value === 'amount') &&
            si_data.discount === 0
        ) {
            return ToastDanger(
                "Discount cannot be 0. Select 'None' if you don't want any discount."
            );
        }

        formdata['delivery_template_id'] = si_data.delivery_template_id;
        formdata['generate_sales_order'] = si_data.generate_so;
        formdata['is_branch'] = si_data.is_branch;
        formdata['branch_id'] = si_data.branch_id;
        // console.log('formdata', formdata);
        DeliveryService.createDR(formdata)
            .then((result) => {
                dispatch({ type: PRE_LOAD, payload: false });
                dispatch({ type: SET_LOADING, payload: true });
                dispatch(drRedirect(true));
                dispatch(clearDelivery());

                if (actions == 'print') {
                    settoPrint(true, result.data.dr.data._id, 'Delivery');
                } else if (actions == 'email') {
                    dispatch(sendEmail(null, result.data.dr.data._id));
                }

                window.location.href = '/deliveries';
            })
            .catch((err) => {
                dispatch({ type: SET_LOADING, payload: false });
                if (err?.data?.errors?.length > 0) {
                    ToastDanger(err.data.errors);
                } else {
                    ToastDanger('Failed create new Delivery Receipt');
                }
                console.log(err);
            });
    };

export const update_delivery =
    (formdata, actions) => async (dispatch, getState) => {
        dispatch({ type: SET_LOADING, payload: true });
        const { delivery_template_id, generate_so } =
            getState().delivery.si_data;

        if (delivery_template_id == '') {
            return ToastDanger('Please Choose Delivery Template');
        }

        formdata['delivery_template_id'] = delivery_template_id;
        if (generate_so != null) {
            formdata.si_data.generate_sales_order = generate_so;
        }
        // console.log("formdata", formdata)
        DeliveryService.updateDR(formdata)
            .then((result) => {
                dispatch({ type: PRE_LOAD, payload: false });
                dispatch(drRedirect(true));
                dispatch(clearDelivery());

                if (actions == 'print') {
                    settoPrint(true, result.data.delivery.data._id, 'Delivery');
                } else if (actions == 'email') {
                    dispatch(sendEmail(null, result.data.delivery.data._id));
                }

                window.location.href = '/deliveries';
            })
            .catch((err) => {
                if (err.data.errors.length > 0) {
                    dispatch({ type: SET_LOADING, payload: false });
                    ToastDanger(err.data.errors);
                } else {
                    ToastDanger('Failed create new Delivery Receipt');
                }
            });
    };

export const drRedirect =
    (status = false) =>
    async (dispatch) => {
        dispatch({ type: DR_REDIRECT, payload: status });
    };

export const get_dr =
    (pageNumber, rows_per_page = null, pageOrigin = null) =>
    async (dispatch, getState) => {
        let {
            search,
            pagination,
            pagination_list,
            status_view,
            dr_type_filter,
            sort_order_name,
            sort_order_direction,
        } = getState().delivery;

        let rows_per_page_val =
            (rows_per_page != null ? rows_per_page : getNumRows('delivery')) ||
            10;

        // const formdata = {
        //   search: search,
        //   activePage: pagination.activePage,
        //   page: pageNumber,
        //   order_direction: sort_order_direction,
        //   order_name: sort_order_name,
        //   paginate: rows_per_page_val, // rows_per_page
        //   product_id: pageOrigin ? pageOrigin["product_id"] : null, // for inventory_view param
        // };

        //** MERN PAGINATE WITH OPTIMIZE SEARCH QUERY */
        let formdata = {
            search,
            options: {
                page: pageNumber,
                limit: rows_per_page_val,
                sort_by: sort_order_name,
                sort_order: sort_order_direction,
            },
        };

        if (dr_type_filter && dr_type_filter !== 'all') {
            formdata.customer_type = dr_type_filter;
        }

        if (pageOrigin) {
            switch (pageOrigin['origin']) {
                case 'inventory_view':
                    formdata.product_id = pageOrigin['product_id'];
                    break;
                case 'customer_history':
                    formdata.customer_id = pageOrigin['customer_id'];
                    break;
                case 'branch_history':
                    formdata.branch_id = pageOrigin['branch_id'];
                    break;
                default:
                    break;
            }
        }

        DeliveryService.getDelivery(formdata, status_view)
            .then((res) => {
                let data_list = [];
                res.data.docs.map((data) => {
                    data_list.push(data);
                });

                pagination_list[status_view] = data_list;

                //** MERN PAGINATE WITH OPTIMIZE SEARCH QUERY */
                let pagination = {
                    totalCount: res.data.total_docs,
                    activePage: res.data.page,
                    itemsCountPerPage: res.data.limit,
                    totalItemsCount: res.data.total_docs,
                };

                // console.log("dr_data", dr_data);
                dispatch({
                    type: GET_DR_STATUS,
                    payload: {
                        pagination_list: pagination_list,
                        pagination: pagination,
                        dr_data: res.data.docs,
                    },
                });
                dispatch(drRedirect(false));
            })
            .catch((err) => {});
    };

export const sortTableByColumn =
    (sort_order_name, sort_order_direction, pageOrigin = null) =>
    async (dispatch) => {
        let sortingParams = {
            sort_order_name: sort_order_name,
            sort_order_direction: sort_order_direction,
        };

        dispatch({ type: SORT_BY_COLUMN, payload: sortingParams });
        dispatch(get_dr(null, null, pageOrigin));
    };

export const handleSearchInputMUI =
    (e, pageOrigin = null) =>
    async (dispatch) => {
        dispatch({ type: SEARCH_INPUT, payload: e.target.value });
        if (e.key === 'Enter') {
            console.log('enter');
            dispatch(get_dr(1, null, pageOrigin));
        }
    };

// handle selec payment type
export const handleSelectPaymentType =
    (selectOption) => async (dispatch, getState) => {
        if (selectOption) {
            dispatch(blockRoute(true));
        } else {
            dispatch(blockRoute(false));
        }

        dispatch({
            type: HANDLE_SI_SELECT_PAYMENT_TYPE,
            payload: selectOption,
        });
    };

// get all the payment_terms and conditions
export const getTermsConditions = () => async (dispatch) => {
    DeliveryService.getTermsConditions()
        .then((res) => {
            let terms_arr = [];
            let payment_terms = res.data.terms_conditions;

            payment_terms.map((val, i) => {
                let select = { value: val.content, label: val.title };
                terms_arr[i] = select;
            });
            terms_arr.unshift({ value: 'none', label: 'None' });

            dispatch({ type: GET_SI_TERMS_CONDITIONS, payload: terms_arr });
        })
        .catch((error) => {
            ToastDanger('Network error, please reload the page.');
            console.log(error);
        });
};

// handle select payment payment_terms
export const handleSelectTermsConditions =
    (selectOption) => async (dispatch, getState) => {
        if (selectOption) {
            dispatch(blockRoute(true));
        } else {
            dispatch(blockRoute(false));
        }
        dispatch({
            type: HANDLE_SI_SELECT_TERMS_CONDITIONS,
            payload: selectOption,
        });

        // If the payment terms is 'none', set receipt type to 'charged sales invoice'
        let receiptType;

        if (selectOption?.value === 'none') {
            receiptType = { value: 'none', label: 'None' };
        } else {
            receiptType = {
                value: 'charged sales invoice',
                label: 'Charged Sales Invoice',
            };
        }

        dispatch(handleSelectReceiptType(receiptType));
    };

export const handleSelectReceiptType =
    (selectedOption) => async (dispatch, getState) => {
        if (selectedOption) {
            dispatch(blockRoute(true));
        } else {
            dispatch(blockRoute(false));
        }

        // Check if the selected option is 'charge sales invoice' and payment mode is 'none'
        const { si_data } = getState().delivery;
        const payment_terms = si_data.payment_terms.value;
        if (
            selectedOption.value === 'charged sales invoice' &&
            payment_terms === 'none'
        ) {
            ToastDanger(
                'You cannot select charge sales invoice if payment terms is none'
            );
            selectedOption = {
                value: 'none',
                label: ' None',
            };
        } else if (
            selectedOption.value != 'charged sales invoice' &&
            payment_terms != 'none'
        ) {
            ToastDanger(
                'You cannot select different receipt type if you selected a payment terms'
            );
            selectedOption = {
                value: 'charged sales invoice',
                label: 'Charged Sales Invoice',
            };
        }

        dispatch({
            type: HANDLE_SI_SELECT_TYPE_RECEIPT,
            payload: selectedOption,
        });
        dispatch(enable_submit_btn());
    };

export const checkBoxManual = (e) => async (dispatch, getState) => {
    if (e) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let { si_data, item_template } = getState().delivery;

    let arr = [];
    let checked = e.target.checked;

    //console.log("item_template", item_template);
    arr.push(item_template);
    if (!checked) {
        arr = [];
    }
    if (si_data.items.length == 0) {
        dispatch({ type: MANUAL, payload: { check: checked, items: arr } });
        dispatch({ type: BOOLEAN_VAR, payload: true });
    } else {
        SwalWarning(
            'Warning!',
            `Selected item(s) will be overwritten, continue?`,
            () => {
                dispatch({ type: BOOLEAN_VAR, payload: true });
                dispatch({
                    type: MANUAL,
                    payload: { check: checked, items: arr },
                });
            },
            console.log('cancelled')
        );
    }
};

export const generateSO = () => async (dispatch, getState) => {
    const {} = getState().delivery;

    DeliveryService.generateSO()
        .then((result) => {
            const so_no = result.data.sales_order_no;

            dispatch({
                type: SET_GENERATE_SO,
                payload: {
                    sales_order_no_reference: so_no,
                },
            });
        })
        .catch((err) => {
            ToastDanger('Failed to load Quotation.');
        });
};

export const handleCreateSO =
    (selectedOption) => async (dispatch, getState) => {
        const selectedValue = selectedOption.value;
        const isSelected = true;
        const isGenerateSO = selectedValue === 'yes';

        if (isGenerateSO) {
            dispatch(generateSO());
        } else {
            dispatch({
                type: SET_GENERATE_SO,
                payload: {
                    sales_order_no_reference: null,
                },
            });
        }

        dispatch({
            type: SET_CREATE_SO,
            payload: {
                is_selected: isSelected,
                generate_so: isGenerateSO,
            },
        });
    };

export const handleSelectCustomerType = (is_branch) => (dispatch) => {
    dispatch({ type: DR_SET_CUSTOMER_TYPE, payload: is_branch });
};

export const searchBranches = (search) => async (dispatch) =>
    new Promise((resolve, reject) => {
        DeliveryService.getBranches(search)
            .then((res) => {
                let customers_arr = [];
                let customers = res.data.customers.data;

                customers.map((val, i) => {
                    let select = {
                        value: val._id,
                        label: val.name,
                        name: 'customer_id',
                    };
                    customers_arr[i] = select;
                });
                resolve(customers_arr);
                // dispatch({ type: GET_SI_CUSTOMERS, payload: customers_arr });
            })
            .catch((error) => {
                // ToastDanger("Network error, please reload the page.");
                console.log(error);
                reject(error);
            });
    });

export const handleSelectBranch = (selectOption) => async (dispatch) => {
    if (selectOption) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    const default_customer_value = {
        value: selectOption.value,
        label: selectOption.label,
    };

    dispatch({
        type: HANDLE_SI_SELECT_BRANCH,
        payload: {
            branch_id: selectOption.value,
            branch_name: selectOption.label,
            branch_subscriber_id: selectOption.branch_subscriber_id,
            branch_user_id: selectOption.branch_user_id,
            default_customer_value,
        },
    });
    dispatch(enable_submit_btn());
};

const item_manual = (items) => {
    let data = {
        options: items,
        _id: null,
        sku: '',
        product_name: '',
        attribute_string: '',
        qty: 1,
        product_unit_name: '',
        srp: 0.0,
        amount: 0.0,
        unit_price: 0.0,
        unit_srp: 0.0,
        selected: false,
        product_value: { value: '', label: 'Choose Product' },
        non_inventory: false,
        unit_barcode: '',
        conversion_to_base: 1,
        product_units: [],
    };

    return data;
};

export const addItem = (e) => async (dispatch, getState) => {
    if (e) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let { items, si_data } = getState().delivery;
    let data_items = si_data.items;

    let errors = false;
    data_items.map((item) => {
        if (item.qty <= 0) {
            ToastDanger('Quantity cannot be zero value, please add at least 1');
            errors = true;
        }
        if (item.srp <= 0) {
            ToastDanger(
                'Unit Price cannot be zero value, please include at least the amount'
            );
            errors = true;
        }
    });

    let data = item_manual(items);
    data_items.push(data);
    dispatch({ type: ADD_ITEM, payload: data_items });
};

export const remItem = (key) => async (dispatch, getState) => {
    let { si_data } = getState().delivery;
    let data_items = si_data.items;
    data_items.splice(key, 1);
    dispatch({ type: ADD_ITEM, payload: data_items });
    dispatch(computationHandler());

    dispatch({ type: COMPUTE_DR, payload: si_data });
};

// // handle select sales invoice templates
// export const handleSelectSalesInvoiceTemplate = selectedOption => async dispatch => {

//     if(selectedOption){
//         dispatch(blockRoute(true));
//     }else{
//         dispatch(blockRoute(false));
//     }

//     let invoice_template_id = selectedOption.value;
//     let inv_default_template = { value: selectedOption.value, label: selectedOption.label };

//     dispatch({ type: HANDLE_SELECT_SI_TEMPLATE, payload: { inv_default_template: inv_default_template, invoice_template_id: invoice_template_id } });
// }

export const getDeliveryTemplates = () => async (dispatch) => {
    try {
        const res = await DeliveryService.getDeliveryTemplates();

        const dr_templates = res.data.delivery_templates;
        const dr_default_template = {
            value: res.data.selected_template._id,
            label: res.data.selected_template.template_name,
        };
        const delivery_template_id = res.data.delivery_template_id;

        let delivery_templates = [];
        dr_templates.map((val, i) => {
            let select = {
                value: val._id,
                label: val.template_name,
                name: 'delivery_template_id',
            };
            delivery_templates[i] = select;
        });

        dispatch({
            type: GET_DR_TEMPLATES,
            payload: {
                delivery_templates,
                dr_default_template,
                delivery_template_id,
            },
        });
    } catch (err) {
        ToastDanger('Network error, please reload the page.');
        $('.btn-remove').removeAttr('disabled').html('Remove');
        console.log(err);
    }
};

export const handleSelectDRTemplate = (selectedOption) => async (dispatch) => {
    if (selectedOption) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    console.log(selectedOption);

    const template = {
        value: selectedOption.value,
        label: selectedOption.label,
    };

    const payload = {
        delivery_template_id: selectedOption.value,
        dr_default_template: template,
    };

    console.log(payload);

    dispatch({ type: SELECT_DR_TEMPLATE, payload });
};

// get all the select options
// export const getCustomers = (default_val) => async (dispatch) => {
//   DeliveryService.getCustomers()
//     .then((res) => {
//       let customers_arr = [];
//       let customers = res.data.customers.data;

//       customers.map((val, i) => {
//         let select = { value: val._id, label: val.name, name: "customer_id" };
//         customers_arr[i] = select;
//       });

//       if (default_val !== undefined) {
//         // console.log("default_val", default_val);
//         dispatch({
//           type: HANDLE_SI_SELECT_CUSTOMER,
//           payload: {
//             customer_id: default_val.value,
//             customer: default_val.label,
//             default_customer_value: default_val,
//           },
//         });
//       }

//       dispatch({ type: GET_SI_CUSTOMERS, payload: customers_arr });
//     })
//     .catch((error) => {
//       ToastDanger("Network error, please reload the page.");
//       console.log(error);
//     });
// };

// get all the select options
export const getCustomers = () => async (dispatch) => {
    DeliveryService.getCustomers('')
        .then((res) => {
            let customers_arr = [];
            let customers = res.data.customers.data;

            customers.map((val, i) => {
                let select = {
                    value: val._id,
                    label: val.name,
                    name: 'customer_id',
                };
                customers_arr[i] = select;
            });

            dispatch({ type: GET_SI_CUSTOMERS, payload: customers_arr });
        })
        .catch((error) => {
            if (error.data.errors.length > 0) {
                error.data.errors.map((err) => ToastDanger(err));
            } else {
                ToastDanger('Network error, please reload the page.');
            }
            console.log(error);
        });
};

export const getBranches = () => async (dispatch) => {
    DeliveryService.getBranches('')
        .then((res) => {
            let branches_arr = [];
            let branches = res.data.branches.data || res.data.branches;

            branches.map((val, i) => {
                let select = {
                    value: val._id,
                    label: val.name,
                    name: 'customer_id',
                    branch_subscriber_id: val.branch_subscriber_id,
                    branch_user_id: val.branch_user_id,
                };
                branches_arr[i] = select;
            });

            dispatch({ type: GET_DR_BRANCH_OPTIONS, payload: branches_arr });
        })
        .catch((error) => {
            console.log(error);
        });
};

// get all the select options
export const searchCustomers = (search) => async (dispatch) =>
    new Promise((resolve, reject) => {
        DeliveryService.getCustomers(search)
            .then((res) => {
                let customers_arr = [];
                let customers = res.data.customers.data;

                customers.map((val, i) => {
                    let select = {
                        value: val._id,
                        label: val.name,
                        name: 'customer_id',
                    };
                    customers_arr[i] = select;
                });
                resolve(customers_arr);
                // dispatch({ type: GET_SI_CUSTOMERS, payload: customers_arr });
            })
            .catch((error) => {
                // ToastDanger("Network error, please reload the page.");
                console.log(error);
                reject(error);
            });
    });

// // get the products
// export const getProducts =
//   (search = "") =>
//   async (dispatch) => {
//     const formdata = {
//       search: search,
//     };
//     DeliveryService.getProducts(formdata)
//       .then((res) => {
//         let items_arr = [];
//         let items = res.data.products.data;
//         // console.log("items", items);
//         items.map((item, i) => {
//           let attribute = "";
//           try {
//             if (
//               item.attribute_string === "()" ||
//               item.attribute_string === null
//             ) {
//               attribute = "";
//             } else {
//               let attr_replace_char = item.attribute_string
//                 .replace("(", "")
//                 .replace(")", "");
//               attribute =
//                 attr_replace_char.slice(0, 40) +
//                 (attr_replace_char.length > 40 ? "..." : "");
//             }
//           } catch (err) {}

//           let select = {
//             _id: item._id,
//             value: item._id,
//             label: item.product_name,
//             sub_label: attribute,
//             name: "item",
//             product_name: item.product_name,
//             barcode: item.barcode,
//             sku: item.sku,
//             qty: 1,
//             product_unit_id: item.product_unit_id ? item.product_unit_id : "",
//             product_unit_name:
//               item.product_unit !== null ? item.product_unit.name : "",
//             attribute_string: item.attribute_string,
//             srp: item.srp,
//             amount: item.srp,
//             description: item.description,
//             new: false,
//             status_code: item.status_code,
//           };

//           items_arr[i] = select;
//         });

//         dispatch({ type: GET_QUOTATION_PRODUCTS, payload: items_arr });
//       })
//       .catch((error) => {
//         ToastDanger("Network error, please reload the page.");
//         console.log(error);
//       });
//   };

// export const searchProducts = (search, index) => (dispatch) =>
//   new Promise((resolve, reject) => {
//     // do something was a success
//     const formdata = {
//       search: search,
//     };
//     DeliveryService.getProducts(formdata)
//       .then((res) => {
//         let items_arr = [];
//         let items = res.data.products.data;

//         items.map((item, i) => {
//           let attribute = "";
//           try {
//             if (
//               item.attribute_string === "()" ||
//               item.attribute_string === null
//             ) {
//               attribute = "";
//             } else {
//               let attr_replace_char = item.attribute_string
//                 .replace("(", "")
//                 .replace(")", "");
//               attribute =
//                 attr_replace_char.slice(0, 40) +
//                 (attr_replace_char.length > 40 ? "..." : "");
//             }
//           } catch (err) {}

//           let select = {
//             _id: item._id,
//             value: item._id,
//             label: item.product_name,
//             sub_label: attribute,
//             name: "item",
//             product_name: item.product_name,
//             barcode: item.barcode,
//             sku: item.sku,
//             qty: 1,
//             product_unit_id: item.product_unit_id ? item.product_unit_id : "",
//             product_unit_name:
//               item.product_unit !== null ? item.product_unit.name : "",
//             attribute_string: item.attribute_string,
//             srp: item.srp,
//             amount: item.srp,
//             description: item.description,
//             new: false,
//             status_code: item.status_code,
//           };

//           items_arr[i] = select;
//         });
//         resolve(items_arr);
//       })
//       .catch((error) => {
//         ToastDanger("Network error, please reload the page.");
//         console.log(error);
//         reject();
//       });

//     // do something was a fail
//   });

// get the products
export const getProducts =
    (search = '') =>
    async (dispatch) => {
        const formdata = {
            search: search,
        };
        DeliveryService.getProducts(formdata)
            .then((res) => {
                let items_arr = [];
                let items = res.data.products.data;
                items.map((item, i) => {
                    // console.log("items", items);
                    let attribute = '';
                    if (
                        item.attribute_string == '()' ||
                        item.attribute_string === null
                    ) {
                        attribute = '';
                    } else {
                        try {
                            let attr_replace_char = item.attribute_string
                                .replace('(', '')
                                .replace(')', '');
                            attribute =
                                attr_replace_char.slice(0, 40) +
                                (attr_replace_char.length > 40 ? '...' : '');
                        } catch (err) {
                            attribute = '';
                        }
                    }

                    let select = {
                        _id: item._id,
                        value: item._id,
                        label: item.product_name,
                        sub_label: attribute,
                        name: 'item',
                        barcode: item.barcode,
                        product_name: item.product_name,
                        brand: item.brand,
                        sku: item.sku,
                        qty: 1,
                        instock: item.instock,
                        product_unit_id: item.product_unit_id
                            ? item.product_unit_id
                            : '',
                        product_unit_name: item.product_unit
                            ? item.product_unit.name
                            : '',
                        attribute_string: item.attribute_string,
                        srp: item.srp,
                        amount: item.srp,
                        description: item.description,
                        lot_no:
                            item.single_lot != null &&
                            item.single_lot != undefined
                                ? item.single_lot.lot_no
                                : '',
                        status_code: item.status_code,
                    };

                    items_arr[i] = select;
                });
                // console.log("items_arr", items_arr);

                dispatch({ type: GET_QUOTATION_PRODUCTS, payload: items_arr });
            })
            .catch((error) => {
                if (error.data.errors.length > 0) {
                    error.data.errors.map((err) => ToastDanger(err));
                } else {
                    ToastDanger('Network error, please reload the page.');
                }
                console.log(error);
            });
    };

export const searchProducts =
    (search, key, new_item_template) => (dispatch, getState) =>
        new Promise((resolve, reject) => {
            // do something was a success
            const { si_data } = getState().delivery;
            const formdata = {
                search: search,
            };
            if (si_data.is_branch && si_data.branch_id) {
                formdata['is_branch'] = true;
                formdata['branch_subscriber_id'] = si_data.branch_subscriber_id;
                formdata['branch_user_id'] = si_data.branch_user_id;
            }
            DeliveryService.getProducts(formdata)
                .then((res) => {
                    let items_arr = [];
                    let items = res.data.products.data;

                    items.forEach((item, i) => {
                        let attribute = '';
                        try {
                            let attr_replace_char = item.attribute_string
                                .replace('(', '')
                                .replace(')', '');
                            attribute =
                                attr_replace_char.slice(0, 40) +
                                (attr_replace_char.length > 40 ? '...' : '');
                        } catch (err) {
                            attribute = '';
                        }

                        // console.log("item", item);
                        let select = {
                            _id: item._id,
                            value: item._id,
                            label: item.product_name,
                            sub_label: attribute,
                            name: 'item',
                            barcode: item.barcode,
                            brand: item.brand,
                            brand_id: item.brand_id,
                            product_name: item.product_name,
                            sku: item.sku,
                            qty: 1,
                            instock: item.instock,
                            product_unit_name: item
                                ? item.product_unit_name
                                : '',
                            product_unit_id: item.product_unit_id,
                            category: item.category,
                            category_id: item.category_id,
                            attribute_string: item.attribute_string,
                            srp: item.srp,
                            amount: item.srp,
                            status_code: item.status_code,
                            description: item.description,
                            unit_price: item.srp,
                            unit_srp: item.srp,
                            product_units: item.product_units,
                            conversion_to_base: item.conversion_to_base,
                            unit_barcode: item.barcode,
                            total_stocks: item.total_stocks,
                            branch_exists: item.branch_exists,
                        };

                        //items_arr[i] = select;
                        items_arr.push(select);
                    });
                    resolve(items_arr);
                })
                .catch((error) => {
                    // ToastDanger("Network error, please reload the page.");
                    console.log(error);
                    reject();
                });

            // do something was a fail
        });

export const handleOnInputChange = (search) => async (dispatch) => {
    const formdata = {
        search: search,
    };

    DeliveryService.getProducts(formdata)
        .then((res) => {
            let items_arr = [];
            let items = res.data.products.data;
            items.map((item, i) => {
                // console.log("item", item);
                let attribute = '';
                if (
                    item.attribute_string == '()' ||
                    item.attribute_string === null
                ) {
                    attribute = '';
                } else {
                    let attr_replace_char = item.attribute_string
                        .replace('(', '')
                        .replace(')', '');
                    attribute =
                        attr_replace_char.slice(0, 40) +
                        (attr_replace_char.length > 40 ? '...' : '');
                }

                const conversion = item.conversion_to_base || 1;
                let select = {
                    _id: item._id,
                    value: item._id,
                    label: item.product_name,
                    sub_label: attribute,
                    name: 'item',
                    barcode: item.barcode,
                    brand: item.brand,
                    product_name: item.product_name,
                    sku: item.sku,
                    qty: 1,
                    instock: item.instock,
                    product_unit_id: item.product_unit_id
                        ? item.product_unit_id
                        : '',
                    product_unit_name: item.product_unit_name || (item.product_unit ? item.product_unit.name : ''),
                    attribute_string: item.attribute_string,
                    srp: item.srp,
                    amount: item.srp * conversion,
                    unit_price: item.srp * conversion,
                    unit_srp: item.srp * conversion,
                    product_units: item.product_units,
                    conversion_to_base: conversion,
                    unit_barcode: item.unit_barcode || item.barcode,
                };

                items_arr[i] = select;
            });
            // console.log("items_arr", items_arr);

            dispatch({ type: GET_QUOTATION_PRODUCTS, payload: items_arr });
            // callback(items_arr);

            return items_arr;
        })
        .catch((error) => {
            // ToastDanger("Network error, please reload the page.");
            console.log(error);
        });
};

export const handleSelectCustomer = (selectOption) => async (dispatch) => {
    if (selectOption) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    DeliveryService.getSingleCustomer(selectOption.value)
        .then((res) => {
            const customerData = res.data.customer;
            let default_customer_value = {
                value: customerData._id,
                label: customerData.name,
            };

            if (customerData.payment_terms) {
                dispatch({
                    type: HANDLE_SI_SELECT_TERMS_CONDITIONS,
                    payload: customerData.payment_terms,
                });
            } else {
                const payment_terms = {
                    value: 'none',
                    label: 'None',
                };
                dispatch({
                    type: HANDLE_SI_SELECT_TERMS_CONDITIONS,
                    payload: payment_terms,
                });
            }

            dispatch({
                type: HANDLE_SI_SELECT_CUSTOMER,
                payload: {
                    customer_id: selectOption.value,
                    customer: customerData.name,
                    default_customer_value: default_customer_value,
                },
            });
            dispatch(enable_submit_btn());
        })
        .catch((error) => {
            ToastDanger('Network error, please reload the page.');
            console.log(error);
        });
};

// handle Select Item
export const handleSelectItem =
    (selectOption, key) => async (dispatch, getState) => {
        if (selectOption) {
            dispatch(blockRoute(true));
        } else {
            dispatch(blockRoute(false));
        }

        let { si_data } = getState().delivery;
        let items = { ...si_data.items[key] };

        let default_product_value = {
            value: selectOption._id,
            label: selectOption.product_name,
        };

        const isProductAlreadySelected = si_data.items.some(
            (item, i) => i !== key && item.product_id === selectOption._id
        );

        // if (isProductAlreadySelected) {
        //     // Display an error message (You can replace this with your preferred way of showing errors)
        //     ToastDanger('Product is already added on the list');
        //     // Remove the row
        //     dispatch(remItem(key));
        // } else
        if (si_data.is_branch && selectOption.branch_exists === false) {
            ToastDanger('Product does not exist in the branch account. Please create the product with a matching product name, SKU, barcode, brand, product unit, and category.');
            dispatch(remItem(key));
        } else if (selectOption.instock === false) {
            ToastWarning('Product is out of stock');
            // Remove the row
            dispatch(remItem(key));
        } else {
            items['product_value'] = default_product_value;
            items['sku'] = selectOption.sku;
            const conversion = parseFloat(selectOption.conversion_to_base) || 1;
            items['product_unit_id'] = selectOption.product_unit_id;
            items['product_unit_name'] = selectOption.product_unit_name;
            items['srp'] = parseFloat(selectOption.srp);
            items['unit_price'] = parseFloat(selectOption.srp) * conversion;
            items['amount'] =
                parseFloat(selectOption.srp) * conversion * parseFloat(items['qty']);
            items['_id'] = selectOption._id;
            items['product_id'] = selectOption._id;
            items['status_code'] = selectOption.status_code;
            items['selected'] = true;
            items['barcode'] = selectOption.barcode;
            items['brand'] = selectOption.brand;
            items['brand_id'] = selectOption.brand_id;
            items['category_id'] = selectOption.category_id;
            items['category'] = selectOption.category;
            items['description'] = selectOption.description;
            items['product_name'] = selectOption.product_name;
            items['discount_type'] = { label: 'None', value: 'none' }; // default discount type
            items['discount'] = 0; // default discount
            items['discount_amount'] = 0;
            items['unit_srp'] = parseFloat(selectOption.srp) * conversion;
            items['product_units'] = selectOption.product_units;
            items['conversion_to_base'] = conversion;
            items['unit_barcode'] = selectOption.unit_barcode || selectOption.barcode;
            items['total_stocks'] = selectOption.total_stocks;
            si_data.items[key] = items;

            dispatch({ type: HANDLE_SI_SELECT_ITEM, payload: si_data.items });
            dispatch({ type: COMPUTE_DR, payload: compute_dr(si_data) });
            dispatch(enable_submit_btn());
        }
    };

export const ShowComboBox = (key) => async (dispatch, getState) => {
    let { si_data } = getState().delivery;
    let items = si_data.items;
    items[key]['selected'] = false;
    dispatch({ type: HANDLE_SI_SELECT_ITEM, payload: items });
};

export const changeQty = (e, key) => async (dispatch, getState) => {
    const { name } = e.target;
    let value = e.target.value;

    const { si_data } = getState().delivery;
    const items = { ...si_data.items[key] };

    if (name === 'qty') {
        // allow empty while typing (so delete works)
        if (value === '') {
            items.qty = '';
        } else {
            // Allow decimal for kilogram units
            const kgUnits = [
                'kg',
                'KG',
                'Kg',
                'kilogram',
                'Kilogram',
                'KILOGRAM',
            ];
            const isKgUnit = kgUnits.includes(items.product_unit_name);

            if (isKgUnit) {
                // Allow decimal input for kg units
                if (/^\d*\.?\d*$/.test(value)) {
                    if (
                        value.endsWith('.') ||
                        value === '' ||
                        (value.includes('.') &&
                            String(parseFloat(value)) !== value)
                    ) {
                        items.qty = value;
                    } else {
                        items.qty = parseFloat(value);
                    }
                } else {
                    e.target.value = String(items.qty ?? '');
                }
            } else {
                // integer qty (prevents 02, 003, NaN)
                const parsed = parseInt(value, 10);
                items.qty = Number.isNaN(parsed) ? '' : Math.max(0, parsed);
            }
        }
    } else {
        items[name] = value;
    }

    // compute safely: treat '' as 0
    const qty = Number(items.qty) || 0;

    // use unit_srp if present else srp
    const price = Number(items.unit_srp ?? items.srp ?? 0);
    items.amount = qty * price;

    // (optional) discount logic if you want it here too
    if (items.discount_type && items.discount_type.value !== 'none') {
        let discountAmount = 0;
        const disc = Number(items.discount) || 0;

        if (items.discount_type.value === 'percent') {
            discountAmount = (disc / 100) * items.amount;
        } else if (items.discount_type.value === 'amount') {
            discountAmount = disc;
        }

        items.amount = items.amount - discountAmount;
        items.discount_amount = discountAmount || 0;
    }

    si_data.items[key] = items;

    dispatch({ type: ADD_ITEM, payload: si_data.items });
    dispatch(computationHandler());

    // Add delivery fee after computation (your existing pattern)
    si_data.total += parseFloat(si_data.delivery_fee || 0);
    dispatch({ type: COMPUTE_DR, payload: si_data });
    dispatch(enable_submit_btn());
};

//** old */
// const compute_dr = (si_data) => {
//   let subtotal = 0,
//     total_qty = 0;
//   si_data.items.map((data, key) => {
//     if (data._id !== null) {
//       subtotal += parseFloat(NaN2zero(data.amount));
//       total_qty += parseFloat(NaN2zero(data.qty));
//     }
//   });
//   // console.log("si_data.discount_type", si_data.discount_type);
//   let discount;
//   switch (si_data.discount_type) {
//     case "":
//       discount = 0;
//       break;
//     case "none":
//       discount = 0;
//       break;
//     case "amount":
//       discount = si_data.discount;
//       break;
//     case "percent":
//       discount = (si_data.discount / 100) * subtotal;
//       break;
//     default:
//       discount = 0;
//       break;
//   }
//   // let discount    = si_data.discount_type == '' ? 0 : si_data.discount_type == 'none' ? 0 : si_data.discount_type == 'amount' ? si_data.discount : ((si_data.discount / 100) * subtotal);
//   si_data.subtotal = subtotal;
//   si_data.total_qty = total_qty;
//   let vat =
//     (parseFloat(NaN2zero(si_data.vat)) / 100) *
//     (subtotal - parseFloat(NaN2zero(discount)));
//   si_data.total =
//     NaN2zero(subtotal) +
//     parseFloat(NaN2zero(blank2Zero(si_data.delivery_fee))) +
//     vat -
//     parseFloat(NaN2zero(blank2Zero(discount)));
//   return si_data;
// };

//** MERN */
const compute_dr = (si_data) => {
    let subtotal = 0,
        total_qty = 0;
    si_data.items.map((data, key) => {
        if (data._id !== null) {
            subtotal += parseFloat(NaN2zero(data.amount));
            total_qty += parseFloat(NaN2zero(data.qty));
        }
    });

    // Ensure the discount value is a number
    let discountValue = parseFloat(NaN2zero(si_data.discount));

    let discount;
    switch (si_data.discount_type) {
        case '':
            discount = 0;
            break;
        case 'none':
            discount = 0;
            break;
        case 'amount':
            discount = discountValue;
            break;
        case 'percent':
            discount = (discountValue / 100) * subtotal;
            break;
        default:
            discount = 0;
            break;
    }

    // Update the previous delivery fee value
    si_data.delivery_fee_prev = parseFloat(
        NaN2zero(blank2Zero(si_data.delivery_fee))
    );

    si_data.subtotal = subtotal;
    si_data.total_qty = total_qty;

    return si_data;
};

export const vat_change = (e) => async (dispatch, getState) => {
    if (e.target.checked) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let check = e.target.checked;
    let { si_data } = getState().delivery;
    si_data.vat = check ? 12 : 0;
    dispatch(computationHandler());

    // Add the delivery fee to the total after calling the computationHandler()
    si_data.total += parseFloat(si_data.delivery_fee || 0);
    dispatch({ type: COMPUTE_DR, payload: si_data });
};

export const deliveryFee = (e) => async (dispatch, getState) => {
    if (e.target.value) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let { si_data } = getState().delivery;
    const value = e.target.value;

    // Allow empty string while typing, parse otherwise
    if (value === '') {
        si_data.delivery_fee = '';
    } else {
        const parsed = parseFloat(value);
        si_data.delivery_fee = isNaN(parsed) ? '' : Math.max(0, parsed);
    }
    dispatch(computationHandler());
};

export const discountType = (e) => async (dispatch, getState) => {
    if (e.target.value) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let { si_data } = getState().delivery;
    si_data.discount_type = e.target.value;
    dispatch(computationHandler());

    // Add the delivery fee to the total after calling the computationHandler()
    si_data.total += parseFloat(si_data.delivery_fee || 0);
    dispatch({ type: COMPUTE_DR, payload: si_data });
};

export const discountInput = (e) => async (dispatch, getState) => {
    if (e.target.value) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let { si_data } = getState().delivery;
    si_data.discount = e.target.value;
    dispatch(computationHandler());

    // Add the delivery fee to the total after calling the computationHandler()
    si_data.total += parseFloat(si_data.delivery_fee || 0);
    dispatch({ type: COMPUTE_DR, payload: si_data });
};

export const refNo = (e) => async (dispatch, getState) => {
    if (e.target.value) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }
    let { si_data } = getState().delivery;
    si_data.reference_no = e.target.value;
    dispatch({ type: COMPUTE_DR, payload: si_data });
};

export const remarksInput = (e) => async (dispatch, getState) => {
    if (e.target.value) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let { si_data } = getState().delivery;
    si_data.remarks = e.target.value;
    dispatch({ type: COMPUTE_DR, payload: si_data });
};

const NaN2zero = (val) => {
    if (isNaN(val)) {
        val = 0;
    }
    return val;
};

const blank2Zero = (val) => {
    if (val == '' || val == null) {
        val = 0;
    }
    return val;
};

const enable_submit_btn = (boolean) => async (dispatch, getState) => {
    let { si_data } = getState().delivery;
    let disabled = true;
    if (
        si_data.items.length > 0 &&
        si_data.customer_id !== null &&
        si_data.total_qty > 0 &&
        si_data.receipt_type.value !== ''
    ) {
        disabled = false;
    }
    dispatch({ type: BOOLEAN_VAR, payload: disabled });
};

export const viewDr = (id) => async (dispatch, getState) => {
    if (id !== null || id !== '') {
        dispatch({ type: MODAL_LOADING, payload: true });
        DeliveryService.getDrData(id)
            .then((result) => {
                //console.log(result.data);
                // console.log(result.data.dr.template_setting);

                let { items } = getState().delivery;
                let data_items = [];
                let subs_setting = result.data.subs_setting;
                let dr = result.data.dr;
                let dr_default_template = [];

                // console.log('result', result);

                if (dr.template_setting) {
                    dr_default_template = {
                        value: dr.template_setting._id,
                        label: dr.template_setting.template_name
                            ? dr.template_setting.template_name
                            : dr.template.template_name,
                    };
                }

                // console.log("test", result.data.dr.items);
                // console.log("TAX", result.data);
                result.data.dr.delivery_items.map((data, key) => {
                    let temp = {
                        options: items,
                        _id: data.product_id,
                        sku: data.sku,
                        product_name: data.product_name,
                        attribute_string: data.product
                            ? data.product.attribute_string
                            : '',
                        qty: data.qty,
                        description: data.description,
                        brand: data.brand,
                        brand_id: data.brand_id ?? null,
                        // product_unit_name: data.product.product_unit
                        //   ? data.product.product_unit.name
                        //   : "",
                        product_id: data.product_id,
                        product_unit_name: data.product_unit_name,
                        product_unit_id: data.product_unit_id ?? null,
                        category: data.category ?? null,
                        category_id: data.category_id ?? null,
                        srp: data.srp,
                        // unit_price: data.unit_price
                        //     ? data.unit_price
                        //     : data.srp,
                        amount: data.amount,
                        product_value: {
                            value: data.product_id,
                            label: data.product_name,
                        },
                        new: true,
                        status_code: data.product
                            ? data.product.status_code
                            : '',
                        barcode: data.product ? data.product.barcode : '',
                        // description: data.product
                        //     ? data.product.description
                        //     : '',
                        discount: data.discount,
                        discount_type: data.discount_type
                            ? data.discount_type
                            : { value: null },
                        discount_amount: data.discount_amount
                            ? data.discount_amount
                            : 0,
                        non_inventory: data.non_inventory,
                        unit_price: data.unit_price,
                        unit_srp: data.srp,
                        product_units: data.product_units,
                        conversion_to_base: data.conversion_to_base,
                        unit_barcode: data.barcode,
                        product_image: data.product_image,
                    };
                    data_items.push(temp);
                });

                let data_dr = result.data.dr;

                // Convert all numeric values to numbers
                data_dr.sub_total = parseFloat(data_dr.sub_total);
                data_dr.discount = parseFloat(data_dr.discount);
                data_dr.vat_amount = data_dr.vat_amount
                    ? parseFloat(data_dr.vat_amount)
                    : 0.0;
                data_dr.tax = data_dr.tax ? parseFloat(data_dr.tax) : 0;
                data_dr.delivery_fee = parseFloat(data_dr.delivery_fee);
                data_dr.total = parseFloat(data_dr.total);

                let si_num = '';

                if (
                    data_dr.quotation !== undefined &&
                    data_dr.quotation != null
                ) {
                    // si_num =
                    //   data_dr.quotation.serial_no !== undefined
                    //     ? data_dr.quotation.serial_no
                    //     : "";
                    si_num =
                        data_dr.quotation.quotation_no !== undefined
                            ? data_dr.quotation.quotation_no
                            : '';
                }

                let si_data = {
                    items: data_items,
                    is_branch: data_dr.is_branch ?? false,
                    branch_id: data_dr.branch_id ?? null,
                    branch_subscriber_id: data_dr.branch ? data_dr.branch.branch_subscriber_id : null,
                    branch_user_id: data_dr.branch ? data_dr.branch.branch_user_id : null,
                    customer: data_dr.is_branch
                        ? (data_dr.branch ? data_dr.branch.name : '')
                        : (data_dr.customer != null ? data_dr.customer : ''),
                    customer_id: data_dr.is_branch ? null : data_dr.customer_id,
                    customer_data: {
                        value: data_dr.is_branch ? (data_dr.branch_id ?? '') : data_dr.customer_id,
                        label: data_dr.is_branch
                            ? (data_dr.branch ? data_dr.branch.name : '')
                            : (data_dr.customer != null ? data_dr.customer.name : ''),
                    },
                    sub_total: data_dr.sub_total,
                    generate_sales_order: data_dr.generate_sales_order,
                    is_selected: data_dr.generate_sales_order !== null,
                    discount: data_dr.discount,
                    discount_type: data_dr.discount_type,
                    vat_amount: data_dr.vat_amount ? data_dr.vat_amount : 0.0,
                    tax: data_dr.tax ? data_dr.tax : 0,
                    tax_type: data_dr.tax_type,
                    delivery_fee: data_dr.delivery_fee,
                    total: data_dr.total,
                    remarks: data_dr.remarks,
                    terms_and_condition: data_dr.terms_and_condition,
                    payment_details: data_dr.payment_details,
                    internal_notes: data_dr.internal_notes,
                    total_qty: data_dr.total_qty,
                    payment_terms: data_dr.payment_terms,
                    receipt_type: data_dr.receipt_type,
                    payment_mode: data_dr.payment_mode,
                    status: data_dr.status,
                    reference_no: data_dr.reference_no, // reference should be from SI
                    reference_id: data_dr.reference_id,
                    manual_input: data_dr.is_manual,
                    sales_order_id: data_dr.sales_order_id,
                    sales_order_no: data_dr.sales_order_no,
                    // si_no: data_dr.si_num,
                    dr_id: data_dr._id,
                    delivery_date: data_dr.delivery_date,
                    delivery_date_string: data_dr.delivery_date,
                    // dr_date: new Date(data_dr.delivery_date),
                    delivery_receipt_no: data_dr.delivery_receipt_no,
                    dr_status: data_dr.status,
                    latest_dr_no: result.data.latest_dr_no,
                    oldest_dr_no: result.data.oldest_dr_no,
                    subs_setting: subs_setting,
                    uploads: data_dr.uploads,
                    logo: data_dr.logo,
                    email_sent:
                        data_dr.email_sent != undefined
                            ? data_dr.email_sent
                            : false,
                    user_prepared_by: data_dr.user_prepared_by,
                    user_checked_by: data_dr.user_checked_by,
                    user_approved_by: data_dr.user_approved_by,
                    delivery_template_id: data_dr.delivery_template_id,
                    dr_default_template,
                    dr_default_template,
                    template_setting: data_dr.template_setting,
                    // template_setting: template_setting,
                };

                si_data.delivery_date = si_data.delivery_date
                    ? new Date(si_data.delivery_date)
                    : new Date();

                si_data.delivery_date_string = si_data.delivery_date_string
                    ? new Date(si_data.delivery_date_string).toLocaleDateString(
                          'en-US'
                      )
                    : new Date().toLocaleDateString('en-US');

                si_data.items.map((item, index) => {
                    si_data.items[index].unit_srp =
                        item.srp * item.conversion_to_base;
                });

                let default_customer_value = data_dr.is_branch
                    ? {
                          value: data_dr.branch_id ?? '',
                          label: data_dr.branch ? data_dr.branch.name : '',
                      }
                    : {
                          value: data_dr.customer && data_dr.customer._id ? data_dr.customer._id : '',
                          label: data_dr.customer ? data_dr.customer.name : '',
                      };

                dispatch({ type: MODAL_LOADING, payload: false });
                dispatch({ type: COMPUTE_DR, payload: si_data });
                dispatch({ type: BOOLEAN_VAR, payload: false });

                if (data_dr.is_branch) {
                    dispatch({ type: DR_SET_CUSTOMER_TYPE, payload: true });
                    dispatch({
                        type: HANDLE_SI_SELECT_BRANCH,
                        payload: {
                            branch_id: data_dr.branch_id,
                            branch_name: data_dr.branch ? data_dr.branch.name : '',
                            branch_subscriber_id: data_dr.branch ? data_dr.branch.branch_subscriber_id : null,
                            branch_user_id: data_dr.branch ? data_dr.branch.branch_user_id : null,
                            default_customer_value,
                        },
                    });
                } else {
                    dispatch({
                        type: HANDLE_SI_SELECT_CUSTOMER,
                        payload: {
                            customer_id: data_dr.customer_id,
                            customer: data_dr.customer != null ? data_dr.customer : '',
                            default_customer_value,
                        },
                    });
                }
                // console.log("result.data", result.data);
            })
            .catch((err) => {
                dispatch({ type: MODAL_LOADING, payload: false });
                console.log(err);
            });
    }
};

export const getDrPicking = (id) => async (dispatch, getState) => {
    if (id !== null || id !== '') {
        dispatch({ type: MODAL_LOADING, payload: true });
        DeliveryService.getDrPicking(id)
            .then((result) => {
                let { items } = getState().delivery;
                let data_items = [];
                let subs_setting = result.data.subs_setting;
                let dr = result.data.dr;

                dr.delivery_items.map((data, key) => {
                    let temp = {
                        options: items,
                        _id: data.product_id,
                        sku: data.sku,
                        product_name: data.product_name,
                        attribute_string: data.product
                            ? data.product.attribute_string
                            : '',
                        qty: data.qty,
                        description: data.description,
                        brand: data.brand,
                        brand_id: data.brand_id ?? null,
                        product_id: data.product_id,
                        product_unit_name: data.product_unit_name,
                        product_unit_id: data.product_unit_id ?? null,
                        category: data.category ?? null,
                        category_id: data.category_id ?? null,
                        srp: data.srp,
                        amount: data.amount,
                        product_value: {
                            value: data.product_id,
                            label: data.product_name,
                        },
                        new: true,
                        status_code: data.product
                            ? data.product.status_code
                            : '',
                        barcode: data.product ? data.product.barcode : '',
                        discount: data.discount,
                        discount_type: data.discount_type
                            ? data.discount_type
                            : { value: null },
                        discount_amount: data.discount_amount
                            ? data.discount_amount
                            : 0,
                        non_inventory: data.non_inventory,
                        unit_price: data.unit_price,
                        unit_srp: data.srp,
                        product_units: data.product_units,
                        conversion_to_base: data.conversion_to_base,
                        unit_barcode: data.barcode,
                        product_image: data.product_image,
                        product_lot: data.product_lot ?? '',
                        expiry_date: data.expiry_date ?? '',
                        location: data.location ?? '',
                    };
                    data_items.push(temp);
                });

                let data_dr = dr;

                // Convert all numeric values to numbers
                data_dr.sub_total = parseFloat(data_dr.sub_total);
                data_dr.discount = parseFloat(data_dr.discount);
                data_dr.vat_amount = data_dr.vat_amount
                    ? parseFloat(data_dr.vat_amount)
                    : 0.0;
                data_dr.tax = data_dr.tax ? parseFloat(data_dr.tax) : 0;
                data_dr.delivery_fee = parseFloat(data_dr.delivery_fee);
                data_dr.total = parseFloat(data_dr.total);

                let si_num = '';

                if (
                    data_dr.quotation !== undefined &&
                    data_dr.quotation != null
                ) {
                    // si_num =
                    //   data_dr.quotation.serial_no !== undefined
                    //     ? data_dr.quotation.serial_no
                    //     : "";
                    si_num =
                        data_dr.quotation.quotation_no !== undefined
                            ? data_dr.quotation.quotation_no
                            : '';
                }

                let si_data = {
                    items: data_items,
                    customer: data_dr.customer != null ? data_dr.customer : '',
                    customer_id: data_dr.customer_id,
                    customer_data: {
                        value: data_dr.customer_id,
                        label:
                            data_dr.customer != null
                                ? data_dr.customer.name
                                : '',
                    },
                    sub_total: data_dr.sub_total,
                    generate_sales_order: data_dr.generate_sales_order,
                    is_selected: data_dr.generate_sales_order !== null,
                    discount: data_dr.discount,
                    discount_type: data_dr.discount_type,
                    vat_amount: data_dr.vat_amount ? data_dr.vat_amount : 0.0,
                    tax: data_dr.tax ? data_dr.tax : 0,
                    tax_type: data_dr.tax_type,
                    delivery_fee: data_dr.delivery_fee,
                    total: data_dr.total,
                    remarks: data_dr.remarks,
                    terms_and_condition: data_dr.terms_and_condition,
                    payment_details: data_dr.payment_details,
                    internal_notes: data_dr.internal_notes,
                    total_qty: data_dr.total_qty,
                    payment_terms: data_dr.payment_terms,
                    receipt_type: data_dr.receipt_type,
                    payment_mode: data_dr.payment_mode,
                    status: data_dr.status,
                    reference_no: data_dr.reference_no, // reference should be from SI
                    reference_id: data_dr.reference_id,
                    manual_input: data_dr.is_manual,
                    sales_order_id: data_dr.sales_order_id,
                    sales_order_no: data_dr.sales_order_no,
                    // si_no: data_dr.si_num,
                    dr_id: data_dr._id,
                    delivery_date: data_dr.delivery_date,
                    delivery_date_string: data_dr.delivery_date,
                    // dr_date: new Date(data_dr.delivery_date),
                    delivery_receipt_no: data_dr.delivery_receipt_no,
                    dr_status: data_dr.status,
                    latest_dr_no: result.data.latest_dr_no,
                    oldest_dr_no: result.data.oldest_dr_no,
                    subs_setting: subs_setting,
                    uploads: data_dr.uploads,
                    logo: data_dr.logo,
                    email_sent:
                        data_dr.email_sent != undefined
                            ? data_dr.email_sent
                            : false,
                    user_prepared_by: data_dr.user_prepared_by,
                    user_checked_by: data_dr.user_checked_by,
                    user_approved_by: data_dr.user_approved_by,
                    delivery_template_id: data_dr.delivery_template_id,
                    template_setting: data_dr.template_setting,
                    // template_setting: template_setting,
                };

                si_data.delivery_date = si_data.delivery_date
                    ? new Date(si_data.delivery_date)
                    : new Date();

                si_data.delivery_date_string = si_data.delivery_date_string
                    ? new Date(si_data.delivery_date_string).toLocaleDateString(
                          'en-US'
                      )
                    : new Date().toLocaleDateString('en-US');

                si_data.items.map((item, index) => {
                    si_data.items[index].unit_srp =
                        item.srp * item.conversion_to_base;
                });

                let default_customer_value = {
                    value:
                        data_dr.customer._id != null
                            ? data_dr.customer._id
                            : '',
                    label:
                        data_dr.customer != null ? data_dr.customer.name : '',
                };

                dispatch({ type: MODAL_LOADING, payload: false });
                dispatch({ type: COMPUTE_DR, payload: si_data });
                dispatch({ type: BOOLEAN_VAR, payload: false });

                dispatch({
                    type: HANDLE_SI_SELECT_CUSTOMER,
                    payload: {
                        customer_id: data_dr.customer_id,
                        customer:
                            data_dr.customer != null ? data_dr.customer : '',
                        default_customer_value: default_customer_value,
                    },
                });
                // console.log("result.data", result.data);
            })
            .catch((err) => {
                dispatch({ type: MODAL_LOADING, payload: false });
                console.log(err);
            });
    }
};

export const delDr = (id) => async (dispatch, getState) => {
    DeliveryService.delDrData(id)
        .then((result) => {
            ToastSuccess(result.data.message);
            window.location.reload();
        })
        .catch((err) => {
            ToastDanger(err.data.message);
        });
};

export const setModal = (modal, status, id, dr_picking) => async (dispatch) => {
    if (modal === 'dr_picking') {
        dispatch({ type: SET_DR_PICKING_TEMPLATE, payload: dr_picking });
        dispatch(getDrPicking(id));
    } else {
        dispatch(viewDr(id));
    }

    dispatch({ type: SET_MODAL, payload: { modal: modal, status: status } });
    settoPrint(false, null, 'Delivery');

    if (status === false) {
        dispatch(delClearUpload());
        // dispatch(clearDelivery());
    }
};

export const setModalSo = (modal, id, status) => async (dispatch) => {
    dispatch(getSingleSalesOrder(id));
    dispatch({ type: SET_MODAL, payload: { modal: modal, status: status } });
    settoPrint(false, null, 'Sales Order');
    if (status === false) {
        dispatch(soClearUpload());
        // dispatch(clearDelivery());
    }
};

export const delClearUpload = () => async (dispatch) =>
    dispatch({ type: DELIVERY_CLEAR_UPLOAD });

export const Print = (id) => async (dispatch) => {
    // console.log('print_id', id);
    DeliveryService.getPrint(id)
        .then((res) => {
            // let newBlob = new Blob([res.data], {type:"application/pdf"});
            // var arrBuffer = dispatch(base64ToArrayBuffer([res.data]));
            let newBlob = new Blob([res.data], { type: 'application/pdf' });

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(newBlob);
                return;
            }
            const url = window.URL.createObjectURL(newBlob);
            const link = document.createElement('a');
            link.href = url;
            let current_datetime = new Date();
            let formatted_date =
                ('0' + (current_datetime.getMonth() + 1)).slice(-2) +
                '-' +
                ('0' + current_datetime.getDate()).slice(-2) +
                '-' +
                current_datetime.getFullYear();
            let file_name = 'deliveries-' + formatted_date + '.pdf';
            link.setAttribute('download', file_name);
            document.body.appendChild(link);
            window.open(link.href, '_blank', 'noopener,noreferrer');
            // link.click();
            window.URL.revokeObjectURL(url);
            link.remove();
        })
        .catch((err) => {
            console.log(err);
        });
};

// handle prev, next page of modals
export const goPage = (direction) => async (dispatch, getState) => {
    dispatch({ type: MODAL_LOADING, payload: true });

    let { si_data } = getState().delivery;

    let params = { direction, _id: si_data.dr_id };

    try {
        const go_to = await DeliveryService.goPage(params);
        dispatch(viewDr(go_to.data._id));
    } catch (e) {
        console.log(e);
        ToastDanger('Server Error');
        dispatch({ type: MODAL_LOADING, payload: false });
    }
};

export const clearDelivery = () => async (dispatch) =>
    dispatch({ type: CLEAR_DELIVERY });

export const handleDiscountItem =
    (key, remove = false) =>
    async (dispatch, getState) => {
        let { si_data } = getState().delivery;
        let items = { ...si_data.items[key] };

        if (!items.product_name) {
            ToastDanger('Please add Product item at least one.');
            return;
        }

        if (remove) {
            items['discount'] = 0;
            items['discount_type'] = { value: 'none', label: 'None' };
            items['discount_amount'] = 0;
            items['amount'] = items.srp;
        }

        si_data.items[key] = items;

        dispatch({
            type: ADD_ITEM,
            payload: si_data.items,
        });

        dispatch({
            type: TOGGLE_DISCOUNT_ROW,
            payload: { key, remove },
        });
    };

export const handleInputDiscountProduct =
    (e, key) => async (dispatch, getState) => {
        let { name, value } = e.target;
        value = parseFloat(value);
        let { si_data } = getState().delivery;
        let items = { ...si_data.items[key] };

        // // Save original amount if not already saved
        // if (!items.hasOwnProperty('original_amount')) {
        //   items['original_amount'] = items.srp;
        // }

        let discountedAmount = 0;
        let discountAmount = 0;

        items.amount = (items.srp || 0) * (items.qty || 0);

        if (value === '0') {
        } else if (items.discount_type.value === 'percent') {
            discountAmount = (value / 100) * items.amount;
            discountedAmount = items.amount - discountAmount;
            items.amount = discountedAmount;
        } else if (items.discount_type.value === 'amount') {
            discountAmount = value;
            discountedAmount = items.amount - value;
            items.amount = discountedAmount;
        }

        items[name] = parseFloat(value);
        items['discount_amount'] = discountAmount ? discountAmount : 0;

        si_data.items[key] = items;
        dispatch({ type: ADD_ITEM, payload: si_data.items });
    };

export const handleSelectDiscountTypeProduct =
    (selectOption, key) => async (dispatch, getState) => {
        let { si_data } = getState().delivery;
        let items = { ...si_data.items[key] };

        // Reset discount amount when changing discount type to 'amount'
        if (selectOption.value === 'amount' || 'percent' || 'none') {
            items.discount_amount = 0;
            items.amount = (items.srp || 0) * (items.qty || 0);
        }

        items.discount_type = selectOption;
        items.discount = 0;

        si_data.items[key] = items;
        dispatch({ type: ADD_ITEM, payload: si_data.items });
    };

export const handleSelectDiscountType = (selectOption) => async (dispatch) => {
    const discountType =
        selectOption.value === 'none'
            ? 'none'
            : selectOption.value === 'percent'
            ? 'percent'
            : 'amount';

    if (selectOption.value === 'none') {
        dispatch({
            type: DELIVERY_INPUT_CHANGE,
            payload: { key: 'discount', value: 0 },
        });
    }

    // Save the whole selectOption object with the string representation of the value
    dispatch({
        type: DELIVERY_INPUT_CHANGE,
        payload: {
            key: 'discount_type',
            value: { ...selectOption, value: discountType },
        },
    });
};

export const handleInputChangeDiscount = (e) => async (dispatch, getState) => {
    if (e.target.value !== '') {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let { si_data } = getState().delivery;
    const value = e.target.value;

    // Allow empty string for typing
    if (value === '') {
        dispatch({
            type: DELIVERY_INPUT_CHANGE,
            payload: { key: e.target.name, value: '' },
        });
        return;
    }

    const parsed = parseFloat(value);

    if (si_data.discount_type.value == 'percent') {
        if (parsed > 100) {
            ToastDanger(
                'If your discount is percentage, discount should not be over 100'
            );
            dispatch({
                type: DELIVERY_INPUT_CHANGE,
                payload: { key: e.target.name, value: 100 },
            });
        } else if (parsed < 0) {
            ToastDanger('Discount should not be less than zero');
            dispatch({
                type: DELIVERY_INPUT_CHANGE,
                payload: { key: e.target.name, value: 0 },
            });
        } else {
            dispatch({
                type: DELIVERY_INPUT_CHANGE,
                payload: {
                    key: e.target.name,
                    value: isNaN(parsed) ? '' : parsed,
                },
            });
        }
    } else {
        if (parsed < 0) {
            ToastDanger('Discount should not be less than zero');
            dispatch({
                type: DELIVERY_INPUT_CHANGE,
                payload: { key: e.target.name, value: 0 },
            });
        } else {
            dispatch({
                type: DELIVERY_INPUT_CHANGE,
                payload: {
                    key: e.target.name,
                    value: isNaN(parsed) ? '' : parsed,
                },
            });
        }
    }
};

// handle inputs
export const handleInputChange = (e) => async (dispatch) => {
    if (e.target.value !== '') {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    dispatch({
        type: DR_INPUT_CHANGE,
        payload: { key: e.target.name, value: e.target.value },
    });
};

export const handleTaxType = (selectOption) => async (dispatch, getState) => {
    let { tax, default_tax } = getState().delivery.si_data;
    tax = selectOption.value === 'none' ? 0 : default_tax;

    dispatch({
        type: DELIVERY_TAX_SELECT_TYPE,
        payload: { tax, tax_type: selectOption },
    });
};

//**old */
// COMPUTATION HANDLER
// export const computationHandler = () => async (dispatch, getState) => {
//   let {
//     si_data: { items, discount, discount_type, tax, tax_type, delivery_fee },
//   } = getState().delivery;

//   // Subtotal and discount
//   const sub_total = items.reduce(
//     (sub, item) => sub + parseFloat(item.amount ? item.amount : item.srp),
//     0
//   );
//   const discounted =
//     discount_type == 1 ? (parseFloat(sub_total) * discount) / 100 : discount;
//   const sub_total_discounted = sub_total - discounted + delivery_fee;

//   // Exclusive Vat     // Formula: price * (vat / 100)
//   const exclusive_vat = (parseFloat(sub_total_discounted) * tax) / 100;
//   const total_w_exclusive =
//     sub_total_discounted +
//     (parseFloat(sub_total_discounted) * tax) / 100 +
//     delivery_fee; // total amount

//   // Inclusive Vat   // Formula: price / ( (vat / 100) + 1)
//   const inclusive_amount = sub_total_discounted / (tax / 100 + 1);
//   const inclusive_vat = sub_total_discounted - inclusive_amount;

//   let payload = {};
//   switch (tax_type.value) {
//     case "exclusive":
//       payload = {
//         sub_total: sub_total,
//         vat_amount: exclusive_vat,
//         total: total_w_exclusive,
//       };
//       break;
//     case "inclusive":
//       payload = {
//         sub_total: sub_total,
//         vat_amount: inclusive_vat,
//         total: sub_total_discounted,
//       };
//       break;
//     default:
//       payload = {
//         vat_amount: 0.0,
//         sub_total: sub_total,
//         total: sub_total_discounted,
//       };
//       break;
//   }

//   // console.log(payload);
//   dispatch({ type: DELIVERY_COMPUTATION_HANDLER, payload });
// };

//**MERN */
export const computationHandler = () => async (dispatch, getState) => {
    let {
        si_data: {
            items,
            discount,
            discount_type,
            tax,
            tax_type,
            delivery_fee,
        },
    } = getState().delivery;

    // Subtotal and discount
    const sub_total = items.reduce(
        (sub, item) => sub + parseFloat(item.amount ? item.amount : item.srp),
        0
    );
    const discounted =
        discount_type.value == 'percent'
            ? (parseFloat(sub_total) * discount) / 100
            : discount;
    const sub_total_discounted =
        sub_total - discounted + parseFloat(delivery_fee || 0);

    // Exclusive Vat     // Formula: price * (vat / 100)
    const exclusive_vat = (parseFloat(sub_total_discounted) * tax) / 100;
    const total_w_exclusive = sub_total_discounted + exclusive_vat;

    // Inclusive Vat   // Formula: price / ( (vat / 100) + 1)
    const inclusive_amount = sub_total_discounted / (1 + tax / 100);
    const inclusive_vat = sub_total_discounted - inclusive_amount;

    let payload = {};
    switch (tax_type.value) {
        case 'exclusive':
            payload = {
                sub_total: sub_total,
                vat_amount: exclusive_vat,
                total: total_w_exclusive,
            };
            break;
        case 'inclusive':
            payload = {
                sub_total: sub_total,
                vat_amount: inclusive_vat,
                total: sub_total_discounted,
            };
            break;
        default:
            payload = {
                vat_amount: 0.0,
                sub_total: sub_total,
                total: sub_total_discounted,
            };
            break;
    }

    // console.log(payload);
    dispatch({ type: DELIVERY_COMPUTATION_HANDLER, payload });
};

export const sendEmail = (e, id) => async (dispatch, getState) => {
    let { email_config } = getState().delivery;
    if (email_config.require_password) {
        verfiyPass(function (result) {
            dispatch(sendSingleEmail(id));
        });
    } else {
        dispatch(sendSingleEmail(id));
    }
};

export const sendSingleEmail = (id) => async (dispatch, getState) => {
    dispatch({ type: SEND_EMAIL, payload: true });
    let { si_data } = getState().delivery;
    DeliveryService.sendEmail(id)
        .then((result) => {
            ToastSuccess(result.data.message);
            dispatch({ type: SEND_EMAIL, payload: false });
            dispatch({ type: RESEND_EMAIL, payload: true });
        })
        .catch((err) => {
            if (err.data == undefined) {
                ToastDanger('Failed to send email.');
            } else {
                ToastDanger(err.data.message);
            }

            dispatch({ type: SEND_EMAIL, payload: false });
            dispatch({ type: RESEND_EMAIL, payload: si_data.email_sent });
        });
};

export const reSendEmail = (e, id) => async (dispatch, getState) => {
    SwalWarning(
        'Are you sure?',
        'Do you really want to resend this email?',
        () => dispatch(sendEmail(e, id))
    );
};

export const getPdf =
    (e, id, delivery_receipt_no, customer, dr_picking) => async (dispatch) => {
        dispatch({ type: DOWNLOAD_BTN, payload: true });

        let formdata = {
            dr_picking,
        };

        // console.log('formdata', formdata);
        // console.log('dr_picking', dr_picking);

        DeliveryService.getPdf(formdata, id)
            .then((result) => {
                const url = window.URL.createObjectURL(new Blob([result.data]));
                const link = document.createElement('a');
                link.href = url;
                let filename = `DR (${delivery_receipt_no}) ${customer}.pdf`;
                link.setAttribute('download', filename); //or any other extension
                document.body.appendChild(link);
                link.click();
                dispatch({ type: DOWNLOAD_BTN, payload: false });
            })

            .catch((err) => {
                dispatch({ type: DOWNLOAD_BTN, payload: false });
                try {
                    ToastDanger(err.data.message);
                } catch (error) {
                    ToastDanger('Failed to generate PDF.');
                }
            });
    };

export const emailConfig = () => async (dispatch) => {
    let x = 0;
    while (x < 3) {
        try {
            const result = await DeliveryService.getEmailConfig();
            dispatch({ type: EMAIL_SETTING_DATA, payload: result.data });
            x = 4;
        } catch (err) {
            // Temporary comment coz of connection timeout
            // ToastDanger('Failed to load email configuration.');
            console.log('error', err);
            x++;
        }
    }
};

const verfiyPass = (callback) => {
    SwallverfiyPass(function (password) {
        let formdata = {
            password: password,
            admin_email: getUserData().admin_email,
        };
        DeliveryService.verifyPassword(formdata)
            .then((result) => {
                SwalSuccessAutoRemove(result.data.message, callback('success'));
            })
            .catch((err) => {
                console.log('err', err);
                try {
                    SwalError(err.data.message);
                } catch (error) {
                    console.log('error', error);
                    SwalError('Unknown error occured');
                }
                // reject(err)
            });
    });
};

export const sendEmailDyanmic =
    (e, id, index) => async (dispatch, getState) => {
        let { dr_data } = getState().delivery;
        let dr = dr_data[index];

        if (dr.email_sent) {
            SwalWarning(
                'Are you sure?',
                'Do you really want to resend this email?',
                () => dispatch(sendByIndex(id, index))
            );
        } else {
            dispatch(sendByIndex(id, index));
        }
    };

const sendByIndex = (id, index) => async (dispatch, getState) => {
    let { email_config } = getState().delivery;
    if (email_config.require_password) {
        verfiyPass(function (result) {
            dispatch(sendEmailIndex(id, index));
        });
    } else {
        dispatch(sendEmailIndex(id, index));
    }
};

const sendEmailIndex = (id, index) => async (dispatch, getState) => {
    let { dr_data } = getState().delivery;
    let dr = dr_data[index];
    dr.sending_email = true;
    dr_data[index] = dr;
    dispatch({ type: DYNAMIC_SEND_EMAIL, payload: dr_data });
    DeliveryService.sendEmail(id)
        .then((result) => {
            ToastSuccess(result.data.message);
            dr.sending_email = false;
            dr.email_sent = true;
            dr_data[index] = dr;
            dispatch({ type: DYNAMIC_SEND_EMAIL, payload: dr_data });
        })
        .catch((err) => {
            // ToastDanger('Failed to send email.');
            if (err.data == undefined) {
                ToastDanger('Failed to send email.');
            } else {
                ToastDanger(err.data.message);
            }
            dr.sending_email = false;
            dr_data[index] = dr;
            dispatch({ type: DYNAMIC_SEND_EMAIL, payload: dr_data });
        });
};

export const dynamiPdf = (e, id, index) => async (dispatch, getState) => {
    let { dr_data } = getState().delivery;
    let dr = dr_data[index];
    dr.download_pdf = true;
    dr_data[index] = dr;
    dispatch({ type: DYNAMIC_SEND_EMAIL, payload: dr_data });
    DeliveryService.getPdf(id)
        .then((result) => {
            const url = window.URL.createObjectURL(new Blob([result.data]));
            const link = document.createElement('a');
            link.href = url;
            let filename = `DR (${dr.delivery_receipt_no}) ${dr.customer}.pdf`;
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();

            dr.download_pdf = false;
            dr_data[index] = dr;
            dispatch({ type: DYNAMIC_SEND_EMAIL, payload: dr_data });
        })

        .catch((err) => {
            dr.download_pdf = false;
            dr_data[index] = dr;
            dispatch({ type: DYNAMIC_SEND_EMAIL, payload: dr_data });
            try {
                ToastDanger(err.data.message);
            } catch (error) {
                ToastDanger('Failed to generate PDF.');
            }
        });
};

// returns selected rows only
export const getSelectedRows =
    (selectedRows, currentRows) => async (dispatch) => {
        // console.log(selectedRows, currentRows)
        let newArray = [];

        currentRows.map((current, i) => {
            selectedRows.map((selected, _i) => {
                if (selected.index == current.index) {
                    let selected = {
                        id: current.data[0],
                        name: current.data[1],
                    };
                    newArray.push(selected);
                }
            });
        });

        // console.log(newArray);
        dispatch({ type: GET_DR_ROWS_TO_DELETE, payload: newArray });
    };

export const confirmDeleteDialogBox = () => async (dispatch, getState) => {
    let { rows_to_delete } = getState().delivery;
    let ir_no = [];

    rows_to_delete.map((rows, i) => {
        ir_no.push('<b>' + rows.name + '</b>');
    });

    SwalWarningHtml(
        'Warning!',
        `Do you want to remove the Delivery Receipt(s): ${ir_no.join(', ')}?`,
        () => dispatch(archiveList())
    );
};

//** MERN */
export const archiveList =
    (pageOrigin = null) =>
    async (dispatch, getState) => {
        let { rows_to_delete } = getState().delivery;
        let id_arr = [];

        rows_to_delete.map((row) => {
            id_arr.push(row.id);
        });
        let params = {
            ids: JSON.stringify(id_arr),
        };
        DeliveryService.archieveList(params)

            .then((res) => {
                switch (res.data.status) {
                    case 0:
                        ToastWarning(res.data.message);
                        break;
                    case 1:
                        ToastSuccess(res.data.message);
                        dispatch(get_dr());
                    default:
                        break;
                }
            })
            .catch((error) => {
                if (error.data.errors.length > 0) {
                    ToastDanger(error.data.errors);
                } else {
                    ToastDanger('Network error, please reload the page.');
                }
                console.log(error);
            });
    };

export const clear_data = () => async (dispatch) => {
    dispatch({ type: CLEAR_DATA });
};

export const cancelDr = () => async (dispatch, getState) => {
    let { si_data } = getState().delivery;
    SwalWarningHtml(
        'Are You Sure?',
        'You are about to cancel Purchase Order <b>' +
            si_data.delivery_receipt_no +
            '</b>. Continue?',
        () => dispatch(passwordCancel())
    );
};

const passwordCancel = () => async (dispatch) => {
    SwallverfiyPass(function (password) {
        let formdata = {
            password: password,
            admin_email: getUserData().admin_email,
            role_id: getUserData().role_id,
            subscriber_id: getUserData().subscriber_id,
            id: getUserData()._id,
        };
        DeliveryService.verifyPassword(formdata)
            .then((result) => {
                SwalSuccessAutoRemove(
                    result.data.message,
                    dispatch(submitCancel())
                );
            })
            .catch((err) => {
                console.log('err', err);
                try {
                    SwalError(err.data.message);
                } catch (error) {
                    console.log('error', error);
                    SwalError('Unknown error occured');
                }
                // reject(err)
            });
    });
};

export const submitCancel = () => async (dispatch, getState) => {
    let { si_data, btn_form } = getState().delivery;
    btn_form.cancel = true;
    dispatch({ type: BTN_FORM, payload: btn_form });
    DeliveryService.cancelDR(si_data.dr_id)
        .then((result) => {
            btn_form.cancel = false;
            dispatch({ type: BTN_FORM, payload: btn_form });
            ToastSuccess(
                'Delivery Receipt: ' +
                    si_data.delivery_receipt_no +
                    ' cancelled'
            );
            dispatch(clearDelivery());
            window.location.href = '/deliveries';
        })
        .catch((err) => {
            btn_form.cancel = false;
            dispatch({ type: BTN_FORM, payload: btn_form });
            try {
                ToastDanger(err.data.message);
            } catch (err) {
                ToastDanger('Failed to cancel Quotation');
            }
        });
};

export const autoPrint = () => async (dispatch) => {
    let toPrint = JSON.parse(gettoPrint('Delivery'));
    if (toPrint !== null) {
        try {
            if (toPrint.print) {
                dispatch(setModal('dr_print_modal', true, toPrint.id));
            }
        } catch (err) {}
    }
};

export const dynamicInputChange = (e, key) => async (dispatch, getState) => {
    if (e.target.value) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let { name, value } = e.target;
    let { si_data } = getState().delivery;
    let items = { ...si_data.items[key] };

    // console.log(' items', items);

    if (name == 'qty') {
        if (value === '') {
            items[name] = '';
        } else {
            // Allow decimal for kilogram units
            const kgUnits = [
                'kg',
                'KG',
                'Kg',
                'kilogram',
                'Kilogram',
                'KILOGRAM',
            ];
            const isKgUnit = kgUnits.includes(items.product_unit_name);

            if (isKgUnit) {
                if (/^\d*\.?\d*$/.test(value)) {
                    if (
                        value.endsWith('.') ||
                        value === '' ||
                        (value.includes('.') &&
                            String(parseFloat(value)) !== value)
                    ) {
                        items[name] = value;
                    } else {
                        items[name] = parseFloat(value);
                    }
                } else {
                    e.target.value = String(items[name] ?? '');
                }
            } else {
                const parsed = parseInt(value, 10);
                items[name] = isNaN(parsed) ? '' : Math.max(0, parsed);
            }
        }
    } else if (
        name === 'product_name' ||
        name === 'product_unit_name' ||
        name === 'sku'
    ) {
        items[name] = value; // Keep as string
    } else {
        items[name] = parseFloat(value);
    }

    if (items.non_inventory) {
        // Non-inventory: always compute from unit_price.
        // When the user types unit_price, mirror it into srp for display columns that use srp/unit_srp.
        if (name === 'unit_price') {
            const up = parseFloat(value) || 0;
            items.srp = up; // keep SRP in sync for UI
            items.unit_srp = up; // if you show SRP per unit, this keeps it consistent
        }
        const price = parseFloat(items.unit_price || 0);
        const qty = parseFloat(items.qty || 0);
        items.amount = qty * price;
        items.discount_type = { value: 'none', label: 'None' }; // keep discounts off for non-inventory
    } else {
        // Inventory items: keep your existing behavior
        const price =
            items.srp !== items.unit_price
                ? parseFloat(items.unit_price || 0)
                : parseFloat(items.srp || 0);
        const qty = parseFloat(items.qty || 0);
        items.amount = qty * price;
    }

    // if (items.discount_type && items.discount_type.value !== 'none') {
    //     let discountAmount = 0;
    //     if (items.discount_type.value === 'percent') {
    //         discountAmount = (items.discount / 100) * items.amount;
    //     } else if (items.discount_type.value === 'amount') {
    //         discountAmount = items.discount;
    //     }
    //     items.amount = items.amount - discountAmount;
    //     items.discount_amount = discountAmount ? discountAmount : 0;
    // }

    si_data.items[key] = items;
    dispatch({
        type: ADD_ITEM,
        payload: si_data.items,
    });

    let bool = false;
    // po_items.map((data, key) =>{
    //     if(data.cost <= 0 || data.srp <= 0 || data.order_qty <= 0)
    //     {
    //         bool = true;
    //     }
    // })
    // dispatch({type : BTN_SUB, payload : bool});
};

// Handle blur input - normalize empty values to 0
export const handleBlurInput =
    (type, index = null, attrName = null) =>
    async (dispatch, getState) => {
        const { si_data } = getState().delivery;

        const isEmpty = (val) =>
            val === '' ||
            val === null ||
            val === undefined ||
            Number.isNaN(val);

        switch (type) {
            case 'discount':
                if (isEmpty(si_data.discount)) {
                    dispatch({
                        type: DELIVERY_INPUT_CHANGE,
                        payload: { key: 'discount', value: 0 },
                    });
                }
                break;

            case 'dynamicQty':
                if (index !== null) {
                    let items = { ...si_data.items[index] };
                    const getPrice = (it) =>
                        it.non_inventory
                            ? parseFloat(it.unit_price || 0)
                            : it.srp !== it.unit_price
                            ? parseFloat(it.unit_price || 0)
                            : parseFloat(it.srp || 0);

                    if (isEmpty(items.qty)) {
                        items.qty = 0;
                        items.amount = 0 * getPrice(items);
                        const newDRItems1 = [...si_data.items];
                        newDRItems1[index] = items;
                        dispatch({ type: ADD_ITEM, payload: newDRItems1 });
                    } else if (typeof items.qty === 'string') {
                        items.qty = parseFloat(items.qty) || 0;
                        items.amount = items.qty * getPrice(items);
                        const newDRItems2 = [...si_data.items];
                        newDRItems2[index] = items;
                        dispatch({ type: ADD_ITEM, payload: newDRItems2 });
                    }
                }
                break;

            case 'attr':
                // Handle delivery_fee field
                if (
                    attrName === 'delivery_fee' &&
                    isEmpty(si_data.delivery_fee)
                ) {
                    dispatch({
                        type: DELIVERY_INPUT_CHANGE,
                        payload: { key: 'delivery_fee', value: 0 },
                    });
                    dispatch(computationHandler());
                }
                break;

            default:
                break;
        }
    };

//** Create product in form */
export const createProduct =
    (index, non_inventory) => async (dispatch, getState) => {
        if (!non_inventory) {
            let { single_sales_order } = getState().sales_order;
            let items = { ...single_sales_order.sales_order_items[index] };
            items.sku = '';
            single_sales_order.sales_order_items[index] = items;
            dispatch({
                type: ADD_ITEM,
                payload: single_sales_order.sales_order_items,
            });
        }

        dispatch({
            type: CREATE_PRODUCT,
            payload: { index, non_inventory },
        });
    };

//** handle form_disable */
export const handleFormDisable = (status) => async (dispatch) =>
    dispatch({ type: HANDLE_ITEM_FORM_DISABLE, payload: status });

//** sku validation */
export const skuSkipValidation = (e, index) => async (dispatch, getState) => {
    let { name, value } = e.target;
    let { si_data } = getState().delivery;
    let items = { ...si_data.items[index] };

    try {
        if (name === 'sku') {
            items[name] = value;
        }

        let params = {
            sku: items.sku,
        };

        await ProductService.skuSkipValidation(params);
        $('#sku').removeClass('is-invalid');
        dispatch(handleFormDisable(false));
    } catch (err) {
        if (err.data.errors) {
            ToastDanger(err.data.errors);
            $('#sku').addClass('is-invalid');
            dispatch(handleFormDisable(true));
        } else {
            ToastDanger('Network error, please reload the page.');
        }
        console.log(err);
    }
};

//** generate SKU */
export const generateSku = (e, index) => async (dispatch, getState) => {
    let { name, value } = e.target;
    let { si_data } = getState().delivery;
    let items = { ...si_data.items[index] };

    await ProductService.generateSku()
        .then((res) => {
            items.sku = res.data.sku;

            si_data.items[index] = items;
            dispatch({
                type: ADD_ITEM,
                payload: si_data.items,
            });
        })
        .catch((err) => {
            if (err.data.errors) {
                ToastDanger(err.data.errors);
            } else {
                ToastDanger('Network error, please reload the page.');
            }
            console.log(err);
        });
};

// handle input datepicker
export const DRDatePicker = (date) => async (dispatch) => {
    // console.log('data', date);
    if (date) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }
    dispatch({ type: SET_DATE_PICKER, payload: date });
};

// handle select product unit for a row
export const handleSelectProductUnit =
    (selectedOption, index) => async (dispatch, getState) => {
        if (selectedOption) {
            dispatch(blockRoute(true));
        } else {
            dispatch(blockRoute(false));
        }

        let { si_data } = getState().delivery;

        let updatedItems = [...si_data.items];
        let updatedItem = { ...updatedItems[index] };

        console.log('updatedItem', updatedItem);

        // ✅ Check stock against conversion
        if (
            updatedItem.total_stocks !== undefined &&
            updatedItem.total_stocks < selectedOption.conversion_to_base
        ) {
            ToastDanger(
                `Not enough stock available. You tried to select a unit that requires ${selectedOption.conversion_to_base} pieces, but only ${updatedItem.total_stocks} are left in stock.`
            );
            return;
        }

        updatedItem.product_unit_id = selectedOption.product_unit_id;
        updatedItem.product_unit_name = selectedOption.name;
        updatedItem.conversion_to_base = selectedOption.conversion_to_base;
        updatedItem.unit_barcode = selectedOption.barcode;
        updatedItem.unit_price =
            updatedItem.srp * updatedItem.conversion_to_base;
        updatedItem.unit_srp = updatedItem.srp * updatedItem.conversion_to_base;
        updatedItem.amount = updatedItem.unit_price * updatedItem.qty;

        updatedItems[index] = updatedItem;
        dispatch({
            type: ADD_ITEM,
            payload: updatedItems,
        });
    };

export const getInternalNotesText = (notes) => {
    if (!notes) return '';

    // Case 1: already a plain string
    if (typeof notes === 'string') {
        return notes;
    }

    // Case 2: array (our normalized backend format)
    if (Array.isArray(notes)) {
        if (notes.length === 0) return '';

        const first = notes[0];

        // [{ message: 'for approval', ... }]
        if (first && typeof first.message === 'string') {
            return first.message;
        }

        // Old nested shape:
        // [{ message: [ { message: 'for approval', ... } ], ... }]
        if (first && Array.isArray(first.message) && first.message.length > 0) {
            const inner = first.message[0];
            if (typeof inner === 'string') return inner;
            if (inner && typeof inner.message === 'string') {
                return inner.message;
            }
        }

        // Fallback if items are strings
        if (typeof first === 'string') {
            return first;
        }

        return '';
    }

    // Case 3: single object { message: '...' }
    if (typeof notes === 'object' && typeof notes.message === 'string') {
        return notes.message;
    }

    return '';
};
